import { post, get } from './api';
import { normalizeTypes } from './helpers';

import { normalizeModelValidationErrors } from './helpers';

export function fetchProfile() {
    return get('profile/get').then((res) => {
        return Promise.resolve({
            ...res,
            data: normalizeTypes(res.data),
        });
    });
}

export function fetchProfileShortInfo() {
    return get('profile/getShortInfo').then((res) => {
        return Promise.resolve({
            ...res,
            data: normalizeTypes(res.data),
        });
    });
}

export function updateProfile(values) {
    return post('profile/update', values)
        .catch((res) => Promise.reject(res));
}

export function chooseEdo(edo) {
    return post('profile/setEdo/' + edo, {});
}

export function requestIntegration() {
    return post('profile/requestInegration', {});
}

export function requestSupport(message) {
    return post('profile/requestSupport', {message});
}

export function requestPackage() {
    return post('profile/requestPackage', {});
}



// WEBPACK FOOTER //
// ./src/services/api/profile.js